import React, { useEffect, useState, Fragment } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import { cyan, yellow } from '@material-ui/core/colors';

import numeral from 'numeral';
import moment from 'moment';
import Taskbar from './Taskbar';
import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';
import agm from '../../services/agm';
import Find from '../expenses/Find';

import Documents from '../occurrences/Documents';
import ResultsActions from '../occurrences/ResultsActions';
import ResultsExpenses from '../occurrences/ResultsExpenses';

import { MdSave } from 'react-icons/md';
import { MdOutlineFileUpload } from 'react-icons/md';
import { MdFileDownload } from 'react-icons/md';
import { FaTasks } from "react-icons/fa";

import PaymentIcon from '@material-ui/icons/Payment';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import {
    KeyboardDatePicker
} from '@material-ui/pickers';

import NumberFormat from 'react-number-format';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Button,
    TextField,
    Collapse,
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    Card,
    CardContent,
    FormControlLabel,
    Checkbox
} from '@material-ui/core';

const ColorCheckbox = withStyles({
    root: {
        marginLeft: 0,
        color: colors.cyan[400],
        '&$checked': {
            color: colors.cyan[500],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
    },
    doned: {
        borderLeft: `10px solid ${cyan[500]}`,
        border: `1px solid ${cyan[500]}`,
        borderRadius: 3,
        padding: 1
    },
    doing1: {
        borderLeft: `10px solid ${yellow[500]}`,
        border: `1px solid ${yellow[500]}`,
        borderRadius: 3,
        padding: 1
    },
    doing2: {
        borderLeft: `10px solid ${yellow[500]}`,
        border: `1px solid ${yellow[500]}`,
        borderRadius: 3,
        padding: 1
    },
    doing3: {
        borderLeft: `10px solid ${yellow[500]}`,
        border: `1px solid ${yellow[500]}`,
        borderRadius: 3,
        padding: 1
    },
    container: {

    },
    grouplabel: {
        color: colors.blue[300]
    },
    groupdivider: {
        borderTop: `1px solid ${colors.blue[300]}`
    },
    expandbutton: {
        background: colors.cyan[500],
        marginTop: -4,
        marginBottom: 5,
    }
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const expensesColumns = [
    { name: 'Código', field: 'item.codigo', size: 50, sortable: 0, exportable: 0 },
    { name: 'Nome', field: 'item.nome', size: -1, sortable: 0, exportable: 0 },
    { name: 'Tipo', field: 'item.tipo.nome', size: -1, sortable: 0, exportable: 0 },
    { name: 'Qtd', field: 'formatDecimal(item.qtd)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Valor Despesa', field: 'formatDecimal(item.valor)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Total Despesa', field: 'formatDecimal(((item.valor * item.qtd)))', size: -1, sortable: 0, exportable: 0 },
    { name: 'Nota', field: 'item.nota', size: -1, sortable: 0, exportable: 0 },
    { name: 'Fornecedor', field: '(item.fornecedor) ? item.fornecedor.nome: ""', size: -1, sortable: 0, exportable: 0 },
    { name: 'Lançado Por', field: 'item.registrador', size: -1, sortable: 0, exportable: 0 },
    { name: 'Em', field: 'formatDate(item.dataRegistro)', size: -1, sortable: 0, exportable: 0 },
    { name: 'Baixado', field: '(item.baixado) ? "Sim" : "Não"', size: -1, sortable: 0, exportable: 0 },
];

const actionsColumns = [
    { name: 'Data', field: 'formatDatetime(item.data)', size: 250, sortable: 0, exportable: 0 },
    { name: 'Descrição', field: 'item.descricao', size: -1, sortable: 0, exportable: 0 },
    { name: 'Registrado por', field: 'item.usuario', size: -1, sortable: 0, exportable: 0 }
];

const expensesEmptyMessage = "Nenhuma Despesa Foi Adicionada.";
const actionsEmptyMessage = "Nenhuma Ação Foi Registrada.";

const expensefullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: expensesEmptyMessage,
    columns: expensesColumns
};

const expensesCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_HIDE,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: expensesEmptyMessage,
    columns: expensesColumns
};

const actionsFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: actionsEmptyMessage,
    columns: actionsColumns
};

const actionsCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: actionsEmptyMessage,
    columns: actionsColumns
};

const actionsResultModes = [actionsFullMode, actionsCompactMode];
const expensesResultModes = [expensefullMode, expensesCompactMode];

const Task = ({ item, open, closeEdition, selectedMode, dependencies, updateValues, openUpload, openDocumentEdition, openDeletionDocument, openVisitEdition, openDeletionVisit, appointments, updateBudgets, updateExpenses, slas, openActionEdition, openDeletionAction }) => {

    const classes = useStyles();
    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});
    const [save, setSave] = useState(true);
    const [openFind, setOpenFind] = useState(false);
    const [produto, setProduto] = useState({});
    const [openDeletionProductDialog, setOpenDeletionProductDialog] = useState(false);
    const [expense, setExpense] = useState({});
    const [openDeletionExpenseDialog, setOpenDeletionExpenseDialog] = useState(false);
    const [openDocuments, setOpenDocuments] = useState(true);

    const closeDeletionProduct = () => {
        setOpenDeletionProductDialog(false);
    }

    const closeDeletionExpense = () => {
        setOpenDeletionExpenseDialog(false);
    }

    const closeFind = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenFind(false);
    };

    const saveBudget = (values, dependencies) => {
        var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
        var itens = dependencies.items;
        var orcamento = {
            id: values.budgetid,
            numero: values.budgetnumero,
            ocorrencia: values.ocorrencia,
            idOcorrencia: values.budgetOCORRENCIA,
            dataCriacao: values.budgetdataCriacao,
            dataEnvio: values.budgetdataEnvio,
            foiExecutado: values.budgetfoiExecutado,
            valorMaoObra: values.budgetvalorMaoObra,
            valorMaterial: values.budgetvalorMaterial,
            valorDesconto: values.budgetvalorDesconto,
            total: values.budgetvalortotal,
            FASE_ORCAMENTO: values.budgetFASE_ORCAMENTO,
            ORCAMENTISTA: values.budgetORCAMENTISTA,
            TECNICO: values.budgetTECNICO,
            atualizarPdf: values.atualizarPdf,
            chavePdf: values.chavePdf,
            servicoExecutar: values.budgetServicoExecutar
        };
        var removes = dependencies.removes;
        agm.put('/orcamentos/' + orcamento.id, { orcamento: orcamento, itens: itens, removes: removes, usuario: usuario }).then((response) => {
            if (!response.data.error) {
                updateBudgets(values, dependencies);
            }

            values.atualizarPdf = false;
        }).catch((error) => {
            console.error(error);
        })
    }

    const getRandomId = () => {
        var min = Math.ceil(9900);
        var max = Math.floor(10000);
        return parseInt(Math.floor(Math.random() * (max - min + 1)) + min) * -1;
    };

    const selectProduct = (values, produto) => {
        values.idProduto = produto.id;
        values.qtdProduto = 1;
        values.codigoProduto = produto.codigo;
        values.nomeProduto = produto.nome;
        values.lpuProduto = produto.lpu;
        values.custoProduto = numeral((produto.custo) ? produto.custo : 0).format('0.00');
        values.bdiProduto = numeral((produto.bdi) ? produto.bdi : 0).format('0.00');
        values.valorProduto = numeral((produto.valor) ? produto.valor : 0).format('0.00');
        values.instalacaoProduto = numeral((produto.instalacao) ? produto.instalacao : 0).format('0.00');
        values.produto = produto;
        closeFind();
    }

    const handleAddItem = async (values) => {
        if (values.idProduto) {
            dependencies.items.push({
                id: getRandomId(),
                qtd: values.qtdProduto,
                valor: values.valorProduto,
                instalacao: values.instalacaoProduto,
                total: (parseFloat(parseFloat(values.valorProduto) * parseFloat(values.qtdProduto)) + (parseFloat(parseFloat(values.instalacaoProduto) * parseFloat(values.qtdProduto)))),
                produto: values.produto
            });
            values.budgetvalorMaoObra = 0.0;
            values.budgetvalorMaterial = 0.0;
            values.budgetvalorDesconto = 0.0;
            for (let index = 0; index < dependencies.items.length; index++) {
                var prod = dependencies.items[index];
                values.budgetvalorMaoObra = (parseFloat(values.budgetvalorMaoObra) + (parseFloat(parseFloat(prod.instalacao) * parseFloat(prod.qtd))));
                values.budgetvalorMaterial = (parseFloat(values.budgetvalorMaterial) + (parseFloat(parseFloat(prod.valor) * parseFloat(prod.qtd))));
            }
            values.budgetvalortotal = (parseFloat(values.budgetvalorMaoObra) + parseFloat(values.budgetvalorMaterial));
            values.idProduto = ''
            values.qtdProduto = '';
            values.codigoProduto = '';
            values.nomeProduto = '';
            values.lpuProduto = '';
            values.custoProduto = '';
            values.bdiProduto = '';
            values.valorProduto = '';
            values.instalacaoProduto = '';
            values.produto = null;
            saveBudget(values, dependencies);
            document.getElementById('codigoProduto').focus();
        } else {
            setOpenFind(true);
        }
    }

    const removeItem = async (itemOrcamento, values) => {
        setProduto({ item: itemOrcamento, values, dependencies });
        setMessage({
            title: 'Produto do Orçamento',
            message: 'Deseja excluir o produto ' + itemOrcamento.nome + '?',
            warn: 'Esta ação irá remover o produto do orçamento e recalcular os valores. Caso o PDF já tenha sido gerado ele precisará ser atualizado selecionando a opção ao lado do botão de Salvar.'
        });
        setOpenDeletionProductDialog(true);
    }

    const saveExpenses = (values, dependencies) => {
        var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
        var itens = dependencies.expenses;
        var removes = dependencies.removes;
        agm.put('/ocorrencias/despesas/' + values.id, { itens: itens, removes: removes, usuario: usuario }).then((response) => {
            if (!response.data.error) {
                updateExpenses(values, dependencies);
            }
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const selectExpense = (values, despesa, estoque) => {
        if (despesa) {
            values.expenseCodigo = despesa.codigo;
            values.expenseNome = despesa.nome;
            values.expenseTipo = despesa.tipo.tipoDespesa;
            values.expenseNotaFornecedor = despesa.fornecedor;
            values.expenseNota = '';
            values.expenseEstoque = estoque;
            values.expenseQtd = 1;
            values.expenseCusto = numeral((despesa.custo) ? despesa.custo : 0).format('0.00');
            values.expenseValor = numeral((despesa.custo) ? despesa.custo : 0).format('0.00');
            values.expenseId = despesa.id;
            values.produto = despesa;
            values.expenseProvider = "";
            closeFind();
        }
    }

    const isNewExpenseItem = (values) => {
        var vlr = values.expenseNome && values.expenseQtd && values.expenseValor;
        if (values.expenseNome && values.expenseQtd && values.expenseValor) {
            values.expenseCusto = values.expenseValor;
        }
        return vlr
    }

    const getTipoDespesa = (dependencies, values) => {
        var tp = values.expenseTipo;
        if (tp) {
            for (let index = 0; index < dependencies.expensesType.length; index++) {
                const element = dependencies.expensesType[index];
                if (element.id == tp) {
                    return element;
                }
            }
        }
        return tp;
    }

    const getFornecedor = (dependencies, values) => {
        if (values.expenseNotaFornecedor) {
            for (let index = 0; index < dependencies.expensesProvider.length; index++) {
                const element = dependencies.expensesProvider[index];
                if (element.id === values.expenseNotaFornecedor) {
                    return element;
                }

            }
        }
        return values.expenseNotaFornecedor;
    }


    const handleAddExpense = (values) => {
        if (values.expenseId || isNewExpenseItem(values)) {
            var newItemExpense = {
                id: getRandomId(),
                qtd: values.expenseQtd,
                valor: values.expenseValor,
                custo: values.expenseCusto,
                codigo: (values.produto && values.produto.codigo) ? values.produto.codigo : '----',
                nome: (values.produto && values.produto.nome) ? values.produto.nome : values.expenseNome,
                produto: (values.produto) ? values.produto : null,
                estoque: values.expenseEstoque,
                tipo: getTipoDespesa(dependencies, values),
                nota: values.expenseNota,
                fornecedor: getFornecedor(dependencies, values),
                registrador: (localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname'))
            };
            dependencies.expenses.push(newItemExpense);
            values.expenseTotalCustos = 0.0;
            values.expenseTotalDespesas = 0.0;
            for (let index = 0; index < dependencies.expenses.length; index++) {
                var expense = dependencies.expenses[index];
                values.expenseTotalCustos = values.expenseTotalCustos + (expense.custo * expense.qtd);
                values.expenseTotalDespesas = values.expenseTotalDespesas + (expense.valor * expense.qtd);
            }
            values.expenseCodigo = '';
            values.expenseNome = '';
            values.expenseTipo = 1;
            values.expenseNotaFornecedor = '';
            values.expenseNota = '';
            values.expenseQtd = '';
            values.expenseCusto = '';
            values.expenseValor = '';
            values.expenseEstoque = '';
            values.expenseId = '';
            values.produto = {};
            saveExpenses(values, dependencies);
            document.getElementById('expenseCodigo').focus();
        } else {
            setOpenFind(true);
        }
    }

    const removeExpense = async (itemExpense, values) => {
        setExpense({ item: itemExpense, values, dependencies });
        setMessage({
            title: 'Despesa da Ocorrência',
            message: 'Deseja excluir a despesa ' + itemExpense.nome + '?',
            warn: 'Esta ação irá remover a despesa da ocorrência e recalcular os valores.'
        });
        setOpenDeletionExpenseDialog(true);
    }

    const handleRemoveExpense = async (value) => {
        var { item, values, dependencies } = value;
        for (let index = 0; index < dependencies.expenses.length; index++) {
            var desp = dependencies.expenses[index];
            if (desp.id == item.id) {
                dependencies.expenses.splice(index, 1);
                dependencies.removes.push(desp);
                break;
            }
        }
        values.expenseTotalCustos = 0.0;
        values.expenseTotalDespesas = 0.0;
        for (let index = 0; index < dependencies.expenses.length; index++) {
            var expense = dependencies.expenses[index];
            values.expenseTotalCustos = values.expenseTotalCustos + (expense.custo * expense.qtd);
            values.expenseTotalDespesas = values.expenseTotalDespesas + (expense.valor * expense.qtd);
        }
        document.getElementById('expenseCodigo').focus();
        document.getElementById('expenseNome').focus();
        saveExpenses(values, dependencies);
        closeDeletionExpense();
        await document.getElementById('expenseCodigo').focus();
    }

    const handleRemoveItem = async (value) => {
        var { item, values, dependencies } = value;
        for (let index = 0; index < dependencies.items.length; index++) {
            var prod = dependencies.items[index];
            if (prod.id == item.id) {
                dependencies.items.splice(index, 1);
                dependencies.removes.push(prod);
                break;
            }
        }
        values.budgetvalorMaoObra = 0.0;
        values.budgetvalorMaterial = 0.0;
        for (let index = 0; index < dependencies.items.length; index++) {
            prod = dependencies.items[index];
            values.budgetvalorMaoObra = (parseFloat(values.budgetvalorMaoObra) + (parseFloat(parseFloat(prod.instalacao) * parseFloat(prod.qtd))));
            values.budgetvalorMaterial = (parseFloat(values.budgetvalorMaterial) + (parseFloat(parseFloat(prod.valor) * parseFloat(prod.qtd))));
        }
        values.budgetvalortotal = (parseFloat(values.budgetvalorMaoObra) + parseFloat(values.budgetvalorMaterial) - parseFloat(values.budgetvalorDesconto));
        document.getElementById('codigoProduto').focus();
        document.getElementById('nomeProduto').focus();
        saveBudget(values, dependencies);
        closeDeletionProduct();
        await document.getElementById('codigoProduto').focus();
    }

    const requestExpenseCode = async (value, values) => {
        if (value != '') {
            await agm.get('/orcamentos/produtos/' + value, {}, {}).then((response) => {
                if (!response.data.error) {
                    var list = response.data;
                    if (list.length > 0) {
                        var produto = list[0];
                        values.expenseCodigo = produto.codigo;
                        values.expenseNome = produto.nome;
                        values.expenseTipo = 'Material';
                        values.expenseQtd = 1;
                        values.expenseCusto = numeral((produto.custo) ? produto.custo : 0).format('0.00');
                        values.expenseValor = numeral((produto.custo) ? produto.custo : 0).format('0.00');
                        values.expenseId = produto.id;
                        values.produto = produto;
                    }
                } else {
                    values.expenseTipo = 'Outros';
                    values.expenseId = getRandomId();
                    values.produto = null;
                }
            }).catch((error) => {
                console.error(error);
            })
        }
    }

    const requestProductCode = async (value, values) => {
        if (value != '') {
            await agm.get('/orcamentos/produtos/' + value, {}, {}).then((response) => {
                if (!response.data.error) {
                    var list = response.data;
                    if (list.length > 0) {
                        var produto = list[0];
                        values.idProduto = produto.id;
                        values.qtdProduto = 1;
                        values.codigoProduto = produto.codigo;
                        values.nomeProduto = produto.nome;
                        values.lpuProduto = produto.lpu;
                        values.custoProduto = numeral((produto.custo) ? produto.custo : 0).format('0.00');
                        values.bdiProduto = numeral((produto.bdi) ? produto.bdi : 0).format('0.00');
                        values.valorProduto = numeral((produto.custo) ? produto.custo : 0).format('0.00');
                        values.instalacaoProduto = numeral((produto.instalacao) ? produto.instalacao : 0).format('0.00');
                        values.produto = produto;
                    }
                } else {
                    values.idProduto = ''
                    values.qtdProduto = '';
                    values.codigoProduto = '';
                    values.nomeProduto = '';
                    values.lpuProduto = '';
                    values.custoProduto = '';
                    values.bdiProduto = '';
                    values.valorProduto = '';
                    values.instalacaoProduto = '';
                    values.produto = null;
                    setMessage(response.data);
                    setOpenAlert(true);
                }
            }).catch((error) => {
                console.error(error);
            })
        }
    }

    const handleAperture = async (value, values) => {
        dependencies.symptomes.map(function (symptom) {
            if (symptom.id === values.symptom) {
                var estimativa = getEstimatedDays(symptom);
                if (estimativa > 0) {
                    var atendance = getEstimatedDaysAtendance(symptom);
                    var conclusion = getestimatedDaysConclusion(symptom);
                    values.dateFirstAtend = moment(new Date(value)).add(atendance, 'days');
                    values.dateConclusion = moment(new Date(value)).add(atendance + conclusion, 'days');
                    setMessage({
                        error: true,
                        warn: true,
                        detail: 'Atenção! Datas de SLA foram atualizadas no ATENDIMENTO.'
                    });
                    setOpenAlert(true);
                }
            }
        });
    }

    const handleSymptom = async (event, values) => {
        dependencies.symptomes.map(function (symptom) {
            if (event.target.value === symptom.id) {
                var estimativa = getEstimatedDays(symptom);
                if (estimativa > 0) {
                    var atendance = getEstimatedDaysAtendance(symptom);
                    var conclusion = getestimatedDaysConclusion(symptom);
                    values.dateFirstAtend = moment(values.dateAperture).add(atendance, 'days');
                    values.dateConclusion = moment(values.dateAperture).add(atendance + conclusion, 'days');
                } else {
                    values.dateFirstAtend = null;
                    values.dateConclusion = null;
                }
            }
        });
    }

    const getEstimatedDaysAtendance = (symptom) => {
        if (symptom.slaAtendimento) {
            var atendimento = symptom.vlrAtendimento;
            if (symptom.slaAtendimento == 'Mês') {
                atendimento = (symptom.vlrAtendimento * 30);
            }
            return atendimento;
        }
        return 0;
    }

    const getestimatedDaysConclusion = (symptom) => {
        if (symptom.slaConclusao) {
            var conclusao = symptom.vlrConclusao;
            if (symptom.slaConclusao == 'Mês') {
                conclusao = (symptom.vlrConclusao * 30);
            }
            return conclusao;
        }
        return 0;
    }

    const getEstimatedDays = (symptom) => {
        var conclusao = getestimatedDaysConclusion(symptom);
        var atendimento = getEstimatedDaysAtendance(symptom);
        var estimativa = (conclusao + atendimento);
        return estimativa;
    }

    const getSymptomName = (symptom) => {
        var estimativa = getEstimatedDays(symptom);
        if (estimativa > 0) {
            if (estimativa > 1) {
                estimativa += ' Dias';
            } else {
                estimativa += ' Dia';
            }
            return symptom.nome + ' [ SLA de ' + estimativa + ' ]';
        } else {
            return symptom.nome + ' [ Sem Estimativa de SLA ]';
        }
    }

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const getStatusSLA = (slas, column, item) => {
        var style = 0;
        var group = (column.name == 'CPA') ? 1 : (column.name == 'CPC') ? 2 : 0;
        slas.forEach(sla => {
            if (sla.ocorrencia == item.id) {
                style = (sla.grupo == 3) ? 3 : group;
            }
        });
        var ret = (style == 1) ? classes.doing1 : (style == 2) ? classes.doing2 : (style == 3) ? classes.doing3 : "";
        return ret;
    }

    return (
        <Fragment>

            <Confirmations item={expense}
                message={message}
                open={openDeletionExpenseDialog}
                close={closeDeletionExpense}
                confirmation={handleRemoveExpense} />

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth className={classes.container} >
                <DialogTitle id="form-dialog-title">
                    <Taskbar item={item} slas={slas}></Taskbar>
                </DialogTitle>
                <DialogContent dividers >


                    <Formik
                        enableReinitialize
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                company: Yup.string().required('A seleção da emnpresa é obrigatória'),
                                contract: Yup.string().required('A seleção do contrato é obrigatória'),
                                dateAperture: Yup.date().required('A data de abertura da ocorrência é obrigatória'),
                                number: Yup.string().max(25).required('O número da ocorrência é obrigatório'),
                                code: Yup.string().max(20).required('A seleção da unidade é obrigatória'),
                                name: Yup.string().required('O centro de custo não foi encontrado'),
                                companyStatus: Yup.string().required('A seleção do tipo de ocorrência é obrigatória'),
                                category: Yup.string().required('A seleção da categoria da ocorrência é obrigatória'),
                                atendType: Yup.string().required('A seleção de tipo de atendimento é obrigatória'),
                                ocorrenceStatus: Yup.string().required('A seleção do status da ocorrência é obrigatória'),
                                occurrenceType: Yup.string().required('A seleção do tipo da ocorrência é obrigatória'),
                                invoiceType: Yup.string().required('A seleção do tipo de nota é obrigatória'),
                                description: Yup.string().required('A descrição é obrigatória'),
                                dateFirstAtend: Yup.date().required('A data de abertura é obrigatória'),
                                symptomLocal: Yup.string().required('A seleção do local do sintoma é obrigatória'),
                                dateConclusion: Yup.date().required('A data de abertura é obrigatória'),
                                conclusionStatus: Yup.string().required('O status de realização é obrigatório'),
                                dateStarted: Yup.date().required('A data de início real é obrigatória'),
                                datefinished: Yup.date().required('A data de finalização real é obrigatória'),
                                timeService: Yup.string().required('Total de horas de execução de serviço'),
                                kmService: Yup.string().required('Total de Quilometros usados na execução do serviço'),
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values, save);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (

                            <form onSubmit={handleSubmit} >

                                <Find open={openFind}
                                    closeFind={closeFind}
                                    selectExpense={selectExpense}
                                    values={values}
                                    selectMode={selectedMode} />

                                <Box className={classes.root} >

                                    <Grid
                                        container
                                        spacing={2}
                                        className={getStatusSLA(slas, { name: 'CPC' }, item)}
                                    >

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>
                                            <Typography className={classes.grouplabel} variant='h4' ><b>SERVIÇO</b></Typography>
                                            <Divider className={classes.groupdivider} ></Divider>
                                        </Grid>


                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none">
                                                <InputLabel shrink required htmlFor="conclusionStatus">Status de Realização</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    required
                                                    error={Boolean(touched.conclusionStatus && errors.conclusionStatus)}
                                                    value={values.conclusionStatus}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Status de Realização"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'conclusionStatus',
                                                        id: 'conclusionStatus',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.conclusionStatusList.map((conclusionStatus) => (
                                                        <MenuItem key={conclusionStatus.id} value={conclusionStatus.id}>{conclusionStatus.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                required={values.conclusionStatus == 1 || values.conclusionStatus == 3}
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                inputVariant="outlined"
                                                id="dateStarted"
                                                label="Data de Início Real"
                                                format="DD/MM/YYYY"
                                                name="dateStarted"
                                                value={values.dateStarted}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("dateStarted", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                required={true}
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                minDate={values.dateStarted}
                                                inputVariant="outlined"
                                                id="datefinished"
                                                label="Data de Finalização Real"
                                                format="DD/MM/YYYY"
                                                name="datefinished"
                                                value={values.datefinished}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("datefinished", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <NumberFormat
                                                fullWidth
                                                required={true}
                                                label="Total de Horas do Serviço"
                                                margin="none"
                                                name="timeService"
                                                id="timeService"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.timeService}
                                                variant="outlined"
                                                customInput={TextField}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={
                                                    { readOnly: false, }
                                                }
                                            />

                                        </Grid>


                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <NumberFormat
                                                fullWidth
                                                required={values.conclusionStatus == 3}
                                                label="Quilometragem do Veículo (Km)"
                                                margin="none"
                                                name="kmService"
                                                id="kmService"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.kmService}
                                                variant="outlined"
                                                customInput={TextField}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={
                                                    { readOnly: false, }
                                                }
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}
                                        >
                                            <TextField
                                                error={Boolean(touched.executed && errors.executed)}
                                                required={values.conclusionStatus == 3}
                                                fullWidth
                                                helperText="Coloque aqui a descrição do Serviço Executado e outros detalhes (1024 caracteres)."
                                                label="Serviço Executado"
                                                rows={5}
                                                size={5}
                                                length={1024}
                                                multiline
                                                margin="none"
                                                name="executed"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.executed}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={
                                                    { readOnly: false, }
                                                }
                                            />
                                        </Grid>

                                    </Grid>

                                </Box>

                                <br></br>
                                <br></br>

                                <Box className={classes.root} >


                                    <Grid
                                        container
                                        spacing={2}
                                        className={getStatusSLA(slas, { name: 'CPC' }, item)}
                                    >

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>
                                            <Fragment>
                                                <Typography
                                                    component="span"
                                                    className={classes.grouplabel}
                                                    variant='h4'
                                                    color="textPrimary">
                                                    <b>DOUMENTOS {"(" + dependencies.documents.length + ")"}</b>
                                                </Typography>
                                                &nbsp;&nbsp;
                                                <Tooltip title="Visualizar Documentos">
                                                    <IconButton className={classes.expandbutton} aria-label="expand row" size="small" onClick={() => { setOpenDocuments(!openDocuments) }} >
                                                        {openDocuments ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                    </IconButton>
                                                </Tooltip>
                                            </Fragment>

                                            <Divider className={classes.groupdivider} ></Divider>
                                        </Grid>

                                        <Grid
                                            container
                                            xs="auto"
                                        >

                                            <Grid item
                                                md={12}
                                                xs={12}>

                                                <Grid
                                                    container
                                                    fullWidth
                                                    spacing={2}
                                                    alignContent="flex-end"
                                                >

                                                    <Grid item
                                                        xs="auto">
                                                        &nbsp;&nbsp;<Button
                                                            color="secondary"
                                                            disabled={isSubmitting || dependencies.documents.length == 0}
                                                            size="small"
                                                            startIcon={<MdFileDownload />}
                                                            variant="contained"
                                                            href={process.env.REACT_APP_AGM_ENDPPOINT + "/documentos/zip/" + values.id}>
                                                            Baixar Arquivos
                                                        </Button>

                                                    </Grid>
                                                    <Grid item
                                                        xs="auto">
                                                        <Button
                                                            color="secondary"
                                                            disabled={isSubmitting || values.ocorrenceStatus == 4 && (values.companyStatus == 6 || values.companyStatus == 7)}
                                                            size="small"
                                                            startIcon={<MdOutlineFileUpload />}
                                                            variant="contained"
                                                            onClick={() => { openUpload(values) }}>
                                                            Enviar Arquivos
                                                        </Button>
                                                    </Grid>

                                                </Grid>

                                            </Grid>

                                            <Grid item
                                                md={12}
                                                xs={12}>

                                                <Collapse in={openDocuments} timeout="auto" unmountOnExit>

                                                    <Documents
                                                        documents={dependencies.documents}
                                                        openDocumentEdition={openDocumentEdition}
                                                        openDeletionDocument={openDeletionDocument}
                                                        mediaViewIconType={true}
                                                    />

                                                </Collapse>

                                            </Grid>

                                        </Grid>

                                    </Grid>

                                </Box>

                                <br></br>
                                <br></br>

                                <Box className={classes.root} >

                                    <Grid
                                        container
                                        spacing={2}
                                        className={getStatusSLA(slas, { name: 'CPC' }, item)}
                                    >

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>
                                            <Typography className={classes.grouplabel} variant='h4' ><b>DESPESAS</b></Typography>
                                            <Divider className={classes.groupdivider} ></Divider>
                                        </Grid>


                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>



                                            <Grid container
                                                direction="row"
                                                justify="flex-start"
                                                alignItems="center"
                                                spacing={2}  >

                                                <Grid
                                                    item
                                                    md={1}
                                                    xs={12}>

                                                    <TextField
                                                        fullWidth
                                                        label="Código"
                                                        margin="none"
                                                        name="expenseCodigo"
                                                        id="expenseCodigo"
                                                        onBlur={e => {
                                                            handleBlur(e);
                                                        }}
                                                        onChange={handleChange}
                                                        value={values.expenseCodigo}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                    />

                                                </Grid>

                                                <Grid
                                                    item
                                                    md={3}
                                                    xs={12}>

                                                    <TextField
                                                        fullWidth
                                                        label="Nome do Item"
                                                        margin="none"
                                                        name="expenseNome"
                                                        id="expenseNome"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.expenseNome}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>

                                                <Grid item
                                                    md={1}
                                                    xs={12}>

                                                    <FormControl variant="outlined" fullWidth>
                                                        <InputLabel shrink htmlFor="expenseTipo">Tipo de Despesa *</InputLabel>
                                                        <Select notched
                                                            required={false}
                                                            fullWidth={true}
                                                            label="Tipo de Despesa *"
                                                            variant="outlined"
                                                            id="expenseTipo"
                                                            name="expenseTipo"
                                                            value={values.expenseTipo}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            inputProps={{
                                                                name: 'expenseTipo',
                                                                id: 'expenseTipo',
                                                            }}
                                                        >
                                                            {dependencies.expensesType.map((type) => (
                                                                <MenuItem key={type.id} value={type.id}>{type.nome}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>


                                                </Grid>

                                                <Grid
                                                    item
                                                    md={1}
                                                    xs={12}>
                                                    <NumberFormat
                                                        fullWidth
                                                        label="Qtd"
                                                        margin="none"
                                                        name="expenseQtd"
                                                        id="expenseQtd"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.expenseQtd}
                                                        variant="outlined"
                                                        decimalScale="2"
                                                        customInput={TextField}
                                                        InputLabelProps={{ shrink: true }}
                                                    />

                                                </Grid>

                                                <Grid
                                                    item
                                                    md={1}
                                                    xs={12}>
                                                    <NumberFormat
                                                        fullWidth
                                                        label="Valor Despesa"
                                                        margin="none"
                                                        name="expenseValor"
                                                        id="expenseValor"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.expenseValor}
                                                        variant="outlined"
                                                        decimalScale="2"
                                                        fixedDecimalScale="true"
                                                        customInput={TextField}
                                                        InputLabelProps={{ shrink: true }}
                                                    />

                                                </Grid>

                                                <Grid
                                                    item
                                                    md="auto"
                                                    xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        maxLength="15"
                                                        label="Número da Nota"
                                                        margin="none"
                                                        name="expenseNota"
                                                        id="expenseNota"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.expenseNota}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                    />

                                                </Grid>

                                                <Grid
                                                    item
                                                    md={2}
                                                    xs={12}>

                                                    <FormControl variant="outlined" fullWidth>
                                                        <InputLabel shrink htmlFor="expenseNotaFornecedor">Fornecedor</InputLabel>
                                                        <Select notched
                                                            autosize={true}
                                                            error={Boolean(touched.expenseNotaFornecedor && errors.expenseNotaFornecedor)}
                                                            value={values.expenseNotaFornecedor}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            label="Fornecedor"
                                                            variant="outlined"
                                                            inputProps={{
                                                                name: 'expenseNotaFornecedor',
                                                                id: 'expenseNotaFornecedor',
                                                            }}
                                                        >
                                                            <MenuItem value={null}>
                                                                <em>Selecione uma das opções abaixo</em>
                                                            </MenuItem>

                                                            {dependencies.expensesProvider.map((fornecedor) => (
                                                                <MenuItem key={fornecedor.id} value={fornecedor.id}>{fornecedor.nome}</MenuItem>
                                                            ))}


                                                        </Select>
                                                    </FormControl>

                                                </Grid>

                                                <Grid item
                                                    md="auto"
                                                    xs={12}>

                                                    <Button
                                                        color="secondary"
                                                        size="medium"
                                                        variant="contained"
                                                        startIcon={<PaymentIcon />}
                                                        onBlur={handleBlur}
                                                        onClick={() => { handleAddExpense(values) }}>
                                                        Adicionar Despesa
                                                    </Button>
                                                </Grid>

                                            </Grid>

                                            <br></br>

                                            <Grid container
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                spacing={1}  >

                                                <Grid item
                                                    md={12}
                                                    xs={12}>

                                                    <ResultsExpenses
                                                        resultset={{
                                                            loaded: true,
                                                            records: dependencies.expenses.length,
                                                            pages: 1,
                                                            page: 1,
                                                            count: dependencies.expenses.length,
                                                            rows: dependencies.expenses
                                                        }}
                                                        resultModes={expensesResultModes}
                                                        icon={PaymentIcon}
                                                        vision={{}}
                                                        selectedMode={selectedMode}
                                                        openEdition={() => { }}
                                                        openDeletion={(itemdesp) => {
                                                            removeExpense(itemdesp, values);
                                                        }}
                                                        openTreatment={() => { }}
                                                        openExportDialog={false}
                                                        values={values}
                                                    />

                                                </Grid>

                                            </Grid>


                                        </Grid>

                                    </Grid>

                                </Box>

                                <br></br>
                                <br></br>

                                <Box className={classes.root} >

                                    <Grid
                                        container
                                        spacing={2}
                                        className={getStatusSLA(slas, { name: 'CPC' }, item)}
                                    >

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>
                                            <Typography className={classes.grouplabel} variant='h4' ><b>AÇÔES</b></Typography>
                                            <Divider className={classes.groupdivider} ></Divider>
                                        </Grid>

                                        <Grid item
                                            md={12}
                                            xs={12}>

                                            <Grid item
                                                xs="auto">
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    variant="contained"
                                                    startIcon={<FaTasks />}
                                                    onClick={() => { openActionEdition({}) }}>
                                                    Adicionar Ação
                                                </Button>
                                            </Grid>


                                        </Grid>

                                        <Grid item
                                            md={12}
                                            xs={12}>

                                            <ResultsActions
                                                resultset={{
                                                    loaded: true,
                                                    records: dependencies.actions.length,
                                                    pages: 1,
                                                    page: 1,
                                                    count: dependencies.actions.length,
                                                    rows: dependencies.actions
                                                }}
                                                resultModes={actionsResultModes}
                                                icon={FaTasks}
                                                vision={{}}
                                                selectedMode={selectedMode}
                                                openEdition={openActionEdition}
                                                openDeletion={openDeletionAction}
                                                openTreatment={() => { }}
                                                openExportDialog={false}
                                                values={values}
                                            />

                                        </Grid>


                                    </Grid>

                                </Box>

                                <br></br>
                                <br></br>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                startIcon={<MdSave />}
                                                type="submit"
                                                variant="contained"
                                                onClick={() => { setSave(true) }}>
                                                Salvar
                                            </Button>
                                        </Grid>

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Fechar
                                            </Button>
                                        </Grid>

                                    </Grid>
                                </Box>

                            </form>

                        )}

                    </Formik>
                </DialogContent>

            </Dialog>

        </Fragment >
    );
};

export default Task;